<!-- condition-rules-manager.component.html -->
@if (isLoading()) {
  <div class="flex justify-center py-12">
    <div
      class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
    ></div>
  </div>
} @else {
  <!--  -->

  <lib-condition-rule-builder
    [parentId]="parentId()"
    [parentType]="parentType()"
    [conditionSetId]="conditionSetId()"
    (conditionSetReady)="conditionSetReady.emit($event)"
  ></lib-condition-rule-builder>
}
